import React from "react";
import { useTranslation } from "@helpers/translate";
import cashOutImage from "@assets/images/futures-modals/close-one-bet.jpg";
import { ConfirmTradeModal } from "./ConfirmTradeModal";
import { CONFIRM_SKIP_FLAG } from "./constants";

/**
 * "Cash out this trade?" — confirms a market close of one open trade
 * (docs/trade-logic.md 2.2 Confirm Cash Out).
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.onClose
 * @param {() => Promise<void> | void} props.onConfirm closes the trade
 */
export const CashOutModal = ({ isOpen, onClose, onConfirm }) => {
  const { __ } = useTranslation();

  return (
    <ConfirmTradeModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      image={cashOutImage}
      title={__("futures.cash_out.title")}
      text={__("futures.cash_out.text")}
      confirmLabel={__("futures.cash_out.confirm")}
      cancelLabel={__("futures.trade_modals.close")}
      skipFlag={CONFIRM_SKIP_FLAG.CASH_OUT}
    />
  );
};
